
import { Options } from "vue-class-component";

import { Col, Row, List, Popup,Field, Toast } from "vant";
import AppUtil from "@/util/AppUtil";
import BaseList from "@/common/BaseList";
import WxUtil from "@/util/WxUtil";
@Options({
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [List.name]: List,
    [Popup.name]: Popup,
   [Field.name]: Field,
  },
})
/**我的欠款 */
export default class User extends BaseList {
  data = {
    /**当前欠款 */
    arrearsCurrent: 0,
    /**已还欠款 */
    arrearsPaid: 0,
    /**欠款总额 */
    arrearsTotal: 0,
  };
  showPay=false;
  payMoney="";
  reqUrl = "/zhMember/arrears/getMemberArrearsList";
  // t=11;
  mounted(): void {
    // this.user.req_data();
    AppUtil.request(
      { url: "/zhMember/arrears/getMemberArrearsMoney", method: "post" },
      this.get_money
    );
  }
  /**获取欠款信息 */
  get_money(res: any) {
    console.log("get_money", res);
    this.data = res.data;
    this.payMoney=this.data.arrearsCurrent.toFixed(2)
  }
  card_click() {
    return this.$router.push({
      path: "/enioyCard/shops",
    });
  }
  btn_click() {
    if(!this.payMoney){
      return Toast("请输入还款金额")
    }
    this.payMoney=parseFloat(this.payMoney).toFixed(2);
  
    if(parseFloat(this.payMoney)>this.data.arrearsCurrent){
      return Toast("还款金额不能大于欠款金额")
    }
    AppUtil.request(
      {
        url: "/zhPay/wxpay/wxJSAPIPay",
        method: "post",
        data: {
          payType: 7,
          payMoney:this.payMoney,
        },
      },
      this.wx_pay
    );
    this.showPay=false
  }
  /**还款明细 */
  repay_click(){
      this.$router.push({
          path:'/arrears/list'
      })
  }
  /**支付欠款 */
  wx_pay(res: any) {
    let that = this;
    WxUtil.get_wx().then((wxsdk) => {
      wxsdk.chooseWXPay({
        timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
        package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
        paySign: res.data.paySign, // 支付签名
        success: function () {
          // 支付成功后的回调函数
          that.$router.push({
            path: "/user",
          });
        },
      });
    });
  }
}
